module.exports = "/images/mw.svg?7eb97a55e1610219af0010fe9889ba03";